// A document that shows the bar, the flavours and the preview at once, since an empty editor explains none of them.
export const SAMPLE_DOCUMENT = `# Markdown

Write on the left, read it back on the right. The bar above the editor marks whatever is selected — **bold**,
*italic*, ~~struck through~~ or \`code\` — and the buttons after it start a heading, a list, a quote or a table.

## Flavours

The select above decides how the text is read, and the table below is itself one of the differences.

| Flavour | Tables | Strikethrough | A single newline |
| --- | --- | --- | --- |
| GitHub Flavored | yes | yes | a space |
| GitHub Flavored, Hard Breaks | yes | yes | a line break |
| CommonMark | no | no | a space |
| Original Markdown | no | no | a space |

## Lists

- [x] Split the page, or hand either half all of it
- [ ] Copy the address bar to share exactly what is on screen

1. A numbered list renumbers itself as it is written
2. A quote, a rule and a fence are each a block of their own

> Nothing is uploaded: the document is parsed in this tab.

\`\`\`js
console.log("fenced code, in the flavour of your choice");
\`\`\`
`;
